import React from 'react'
import img1 from '../../images/pexels-los-muertos-crew-8460371.jpg'
import img2 from '../../images/pexels-curtis-adams-3935328.jpg'
import img3 from '../../images/pexels-oles-kanebckuu-127873.jpg'
import BGBlue from '../../images/blue-bg2.jpg'

const CertifiedAgent = () => (
  <div
    className="component"
    style={{
      background: `url(${BGBlue}) center no-repeat`,
      backgroundSize: 'cover',
    }}
  >
    <div className="container">
      <h2 className="text-center text-white mb-5">
        Work with a certified agent you can trust.
      </h2>
      <div className="row justify-content-center">
        {features?.map(item => (
          <div className="col-sm-6 col-md-4 pb-4" key={item?.title}>
            <div className="card">
              <div
                className="w-100 h-0"
                style={{
                  paddingBottom: '75%',
                  backgroundImage: `url(${item?.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              />
              <div className="p-3 text-center">
                <h3 className="h4 mb-3">{item?.title}</h3>
                <p>{item?.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
)

export default CertifiedAgent

const features = [
  {
    title: 'Physician Loan Programs',
    desc:
      'We work with lenders who offer specialized programs for Physicians and Medical Professionals, designed to make homeownership more attainable, despite student loan debt.',
    image: img1,
  },
  {
    title: 'Area Expertise',
    desc:
      'Brian Boals is a Colorado Springs native and our team has over 55 years of combined real estate experience. We listen to your needs and recommend the safest neighborhoods, best area schools, recreation, and anything based on your needs and wants.',
    image: img2,
  },
  {
    title: 'Partnerships with Hospitals',
    desc:
      'We have relationships with the hospitals and medical facilities in the greater Colorado Springs area.',
    image: img3,
  },
]
